"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useToggleState", {
    enumerable: true,
    get: function() {
        return _useToggleState.useToggleState;
    }
});
const _useToggleState = require("./useToggleState");
